/**
 * 员工 表单配置处理
 * @author zjs
 * @time 2017-12-11
 */
export default {
    data () {
        return {
            formConfig: [{
                name: "员工姓名",
                type: "ElInput",
                field: "name"
            }, {
                name: "登录手机号",
                type: "ElInput",
                field: "phone"
            }, {
                name: "初始密码",
                type: "ElInput",
                field: "password",
                json: {
                    disabled: true
                },
                default: "123456"
            }, {
                name: "员工角色",
                type: "LySelect",
                json: { 
                    all: false,
                    api: 'api/roledisplay'
                },
                field: "role_display_id"
            }, {
                name: "负责业务线",
                type: "ElInput",
                field: "fuze_ywx"
            }, {
                name: "登录状态",
                type: "LySelect",
                json: {
                    all: false,
                    data: [{
                        value: 'true',
                        label: '可登录'
                    }, {
                        value: 'false',
                        label: '不可登录'
                    }]
                },
                field: "is_login",
                default: 'true'
            }, {
                name: "权限分配",
                type: "LySelect",
                field: "quanxian_id",
                json: { 
                    all: false,
                    api: 'api/getquanxianlist'
                }
            }, {
                name: "岗位名称",
                type: "ElInput",
                field: "gangwei_name",
                default: "无"
            }, {

                name: "生日",
                type: "LyDatePicker",
                field: "birthday",
                json: {
                    type: 'date',
                    isToday: false
                }
            }, {
                name: "备注",
                type: "ElInput",
                field: "mark",
                width: '1005px',
                json: {
                    span: 24
                },
                default: ""
            }, {
                name: "选择可查看仓库",
                type: "LySelectWarehouse",
                field: "warehouse_ids",
                width: '1005px',
                json: {
                    span: 24
                },
                default: []
            }, {
                name: "支出与余额查看",
                type: "LySelect",
                json: {
                    all: false,
                    data: [{
                        value: '1',
                        label: '允许查看'
                    }, {
                        value: '0',
                        label: '不允许查看'
                    }]
                },
                field: "employee_zhichu_yue",
                default: '1'
            }, {
                name: "待审核、作废查看",
                type: "LySelect",
                json: {
                    all: false,
                    data: [{
                        value: '1',
                        label: '允许查看'
                    }, {
                        value: '0',
                        label: '不允许查看'
                    },
                    {
                        value: '2',
                        label: '仅该账户创建单据'
                    }
                    ]
                },
                field: "is_shenhezuofeichakan",
                default: '1'
            }, {
                name: "单据查看权限",
                type: "LySelect",
                json: {
                    all: false,
                    data: [{
                        value: '0',
                        label: '所有单据'
                    }, {
                        value: '1',
                        label: '仅该账户创建或审核单据'
                    }]
                },
                field: "read_self_bill_only"
            }, {
                name: "是否允许审核",
                type: "LySelect",
                json: {
                    all: false,
                    data: [{
                        value: '1',
                        label: '允许'
                    }, {
                        value: '0',
                        label: '不允许'
                    }]
                },
                field: "allow_check"
            }, {
                name: "开单价格浮动比例",
                type: "LyInputNumber",
                field: "price_float",
                width: '220px',
                
                default: ""
            }]
        }
    }
}